const routergroups = (state = [], action) => {
    switch (action.type) {
      case 'ROUTERGROUP':
        return action.routergroups.map(result => {
          return result
        })
      default:
        return state
    }
  }
  
  export default routergroups